// extracted by mini-css-extract-plugin
export default {"sendMail":"SendMail_sendMail__pWm0W"};